import { Card, Col, Form, Input, Row, Space, Typography } from "antd";
import React, { useMemo, useCallback } from "react";
import { useTranslation } from "react-i18next";
const { Title } = Typography;


const Requester = ({ getChildData }) => {
  const { t, i18n } = useTranslation();
  
  const callparent = (e, name) => {
    getChildData(e, name)
  }
  
  // Memoize validatePhone to prevent unnecessary re-renders
  const validatePhone = useCallback((_, value) => {
    // Example regex for phone number validation (adjust as needed)
    const phoneRegex = /^[+]?[0-9]{10,15}$/;
    if (!value || phoneRegex.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(new Error(t("common:please_enter_a_valid_phone_number")));
  }, [t]);

  // Memoize validation rules so they update when language changes
  const validationRules = useMemo(() => ({
    firstName: [
      { required: true, max: 50, message: t("patientDetails:please_enter_first_name") }
    ],
    lastName: [
      { required: true, max: 50, message: t("patientDetails:please_enter_last_name") }
    ],
    email: [
      { required: true, max: 100, message: t("patientDetails:please_enter_email") },
      { type: "email", message: t("patientDetails:please_enter_valid_email") }
    ],
    phone: [
      { required: true, max: 20, message: t("patientDetails:please_enter_phone_number") },
      { validator: validatePhone }
    ]
  }), [t, validatePhone]); // Re-create rules when language changes

  return (
    <Card
      styles={{ body: { padding: 0 }, header: { marginBottom: 20 } }}
      bordered={false}
      size="0"
      title={
        <Title
          className="font-semibold"
          style={{ marginBottom: "0" }}
          level={4}
        >
          {t("patientDetails:requester_information")}
        </Title>
      }
    >
      <Row gutter={[20, 0]} className="px-1 lg:px-6 mb-4">
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterFName")}
            name="rfirstname"
            label={t("patientDetails:first_name")}
            rules={validationRules.firstName}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterLName")}
            name="rlastname"
            label={t("patientDetails:last_name")}
            required
            rules={validationRules.lastName}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterEmail")}
            name="requesteremail"
            label={t("patientDetails:email")}
            rules={validationRules.email}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterPhoneNumber")}
            name="requesterphone"
            label={t("patientDetails:phone_number")}
            rules={validationRules.phone}
          >
            <Input maxLength={20} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterAddLine1")}
            label={t("patientDetails:address_line_1")}
            name="raddress1"

          >
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            layout="vertical" name="raddress2" label={t("patientDetails:address_line_2")} onChange={(e) => callparent(e.target.value, "RequesterAddLine2")}>
            <Input maxLength={150} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterCity")}
            name="rcity"
            label={t("patientDetails:city")}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterState")}
            name="rstate"
            label={t("patientDetails:state")}
          >
            <Input maxLength={50} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            onChange={(e) => callparent(e.target.value, "RequesterZipCode")}
            name="rzipcode"
            label={t("patientDetails:zip_code")}
          >
            <Input maxLength={8} />
          </Form.Item>
        </Col>
      </Row>

      <Space direction="horizontal" className="px-1 md:px-6">
        <i className="text-base notes-ilatic">
          {t('patientDetails:Please_note')} <u>{t('patientDetails:may_be')}</u> {t('patientDetails:a')} <u> {t('patientDetails:fee')}</u> {t('patientDetails:for_processing_your_request')} <u>{t('patientDetails:requester')}</u> {t('patientDetails:with_the_next_steps_for_payment_collection')}
        </i>
      </Space>
    </Card>
  );
};


export default Requester;
